<template>
    <div>
        <Separator :label="$t('page.information')"></Separator>
        <div class="container-fluid__with-padding">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-8 col-12">
                    <div class="unica-16">{{ formattedDate }}</div>
                    <div class="unica-16" v-if="event.place">{{ event.place }}</div>
                    <div class="unica-16" v-if="event.address">{{ event.address }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Separator from './Separator'
    import FormatDateMixin from '../../../mixins/format-date'

    export default {
        name: "Information",
        mixins: [FormatDateMixin],
        components: {
            Separator
        },
        props: {
            event: '',
        },
        computed: {
            formattedDate: function() {
                return this.getFormatedDate(this.event)
            }
        },
    }
</script>

